import { get } from 'lodash';
export default {
    components: {
        DeepViewDrawer: () => import('library-@/components/deep-view/drawer.vue'),
    },
    data() {
        return {
            DeepView_Lab_Mixin_currentDeepViewData: undefined
        };
    },
    watch: {
        '$route': {
            handler: function () {
                this.DeepView_Lab_Mixin_currentDeepViewData = undefined;
            },
            immediate: true
        },
    },
    computed: {
        DeepView_Lab_Mixin_isDeepViewLabOn() {
            return get(window, 'zPREFACE.usedAnchorInLab.PATENT_DEEP_VIEW.enabled', false);
        }
    },
    mounted() {
        this.$eventHub.$on('PATENT_VIEW:DeepView_Lab_Mixin_toggleDeepViewIcon', (rowData) => {
            this.DeepView_Lab_Mixin_toggleDeepViewIcon(rowData);
        });
    },
    beforeDestroy() {
        this.$eventHub.$off('PATENT_VIEW:DeepView_Lab_Mixin_toggleDeepViewIcon');
    },
    methods: {
        DeepView_Lab_Mixin_toggleDeepViewIcon(rowData) {
            if (
                this.DeepView_Lab_Mixin_currentDeepViewData && this.DeepView_Lab_Mixin_currentDeepViewData.PATENT_ID === rowData.PATENT_ID
            ) {
                this.DeepView_Lab_Mixin_currentDeepViewData = undefined;
            } else {
                this.DeepView_Lab_Mixin_currentDeepViewData = rowData;
            }
        }
    },
};
